var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('a-tree-select',{staticStyle:{"width":"100%"},attrs:{"tree-data":_vm.eventOptions,"treeNodeFilterProp":"title","tree-checkable":"","show-checked-strategy":_vm.SHOW_PARENT,"search-placeholder":"Auswahl"},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }